import {NgModule} from '@angular/core';
import {MaterialModule} from '../../app.material.module';
import {CommonModule} from '@angular/common';
import {TestCardComponent} from './card/test-card.component';
import {ButtonModule} from '../button/button.module';
import {TestResultaatComponent} from './resultaat/test-resultaat.component';
import {RadarChartModule} from '../radar-chart/radar-chart.module';
import {CompetenceListModule} from '../competence-list/competence-list.module';
import {DimensionListComponent} from './dimension-list/dimension-list.component';

@NgModule({
  declarations: [TestCardComponent, TestResultaatComponent, DimensionListComponent],
  imports: [MaterialModule, CommonModule, ButtonModule, RadarChartModule, CompetenceListModule],
  exports: [TestCardComponent, TestResultaatComponent, DimensionListComponent]
})
export class TestModule {
}
